<template>
  <div class="debt-receipt-template is-a5">
    <!-- Header: Store Info -->
    <div class="header text-center mb-3">
      <div v-if="settings.showCompanyLogo && system.logo" class="logo mb-1">
        <img :src="system.logo" style="max-height: 50px;">
      </div>
      <div class="company-name font-weight-bold" style="font-size: 1.3rem;">{{ system.storeName }}</div>
      <div class="company-detail">Địa chỉ: {{ system.address }}</div>
      <div class="company-detail">Điện thoại: {{ system.phone }}</div>
    </div>

    <!-- Receipt Title -->
    <div class="text-center bill-title-section mt-4 mb-4">
        <h4 class="bill-title font-weight-bold">{{ data.isCurrentDebt ? (config.currentDebtTitle || 'PHIẾU BÁO CÔNG NỢ') : (config.title || 'PHIẾU BIÊN NHẬN THANH TOÁN') }}</h4>
    </div>

    <!-- Transaction Info -->
    <div class="info-section mb-4">
      <div class="info-row d-flex justify-content-between mb-2">
        <span class="info-left"><b>Khách hàng / Đối tượng:</b> {{ data.partnerName }}</span>
        <span class="info-right" v-if="data.partnerPhone"><b>SĐT:</b> {{ data.partnerPhone }}</span>
      </div>
      <div class="info-row d-flex justify-content-between mb-2">
        <span class="info-left"><b>Thời gian:</b> {{ formatDateTime(data.createdAt || new Date()) }}</span>
        <span class="info-right"><b>Người lập phiếu:</b> {{ data.createdBy || 'Admin' }}</span>
      </div>
      <div class="info-row mb-2" v-if="data.note">
        <span class="info-left d-block"><b>Ghi chú:</b> {{ data.note }}</span>
      </div>
    </div>

    <!-- Payment Details -->
    <div class="payment-details-section mb-4">
      <!-- Standard Payment Receipt Table -->
      <table v-if="!data.isCurrentDebt" class="table table-bordered border-dark">
        <tbody>
          <tr>
            <td v-if="data.oldDebt < 0" class="font-weight-bold" style="width: 50%">Tổng tiền cọc cũ:</td>
            <td v-else class="font-weight-bold" style="width: 50%">Tổng nợ cũ:</td>
            <td class="text-right font-weight-bold">{{ Number(Math.abs(data.oldDebt || 0)).toLocaleString() }}₫</td>
          </tr>
          <tr>
            <td class="font-weight-bold">Số tiền thanh toán:</td>
            <td class="text-right font-weight-bold text-success">{{ Number(data.paidAmount || 0).toLocaleString() }}₫</td>
          </tr>
          <tr>
            <td class="pl-4"><i>- Tiền mặt:</i></td>
            <td class="text-right"><i>{{ Number(data.cashAmount || 0).toLocaleString() }}₫</i></td>
          </tr>
          <tr>
            <td class="pl-4"><i>- Chuyển khoản:</i></td>
            <td class="text-right"><i>{{ Number(data.transferAmount || 0).toLocaleString() }}₫</i></td>
          </tr>
          <tr>
            <td v-if="data.newDebt < 0" class="font-weight-bold">Tiền cọc mới:</td>
            <td v-else class="font-weight-bold">Dư nợ còn lại:</td>
            <td :class="['text-right', 'font-weight-bold', data.newDebt < 0 ? 'text-success' : 'text-danger']">
                {{ Number(Math.abs(data.newDebt || 0)).toLocaleString() }}₫
            </td>
          </tr>
        </tbody>
      </table>

      <!-- Current Debt Report Table -->
      <table v-else class="table table-bordered border-dark mt-5">
        <tbody>
          <tr>
            <td v-if="data.partnerType === 'customer' && data.currentDebt < 0" class="font-weight-bold p-4" style="width: 50%; font-size: 30px;">Tổng tiền cọc hiện tại:</td>
            <td v-else-if="data.partnerType === 'supplier' && data.currentDebt < 0" class="font-weight-bold p-4" style="width: 50%; font-size: 30px;">Cửa hàng đang dư nợ (Cọc NCC):</td>
            <td v-else class="font-weight-bold p-4" style="width: 50%; font-size: 30px;">Tổng dư nợ hiện tại:</td>

            <td v-if="data.currentDebt < 0" class="text-right font-weight-bold text-success p-4" style="font-size: 36px;">{{ Number(Math.abs(data.currentDebt)).toLocaleString() }}₫</td>
            <td v-else class="text-right font-weight-bold text-danger p-4" style="font-size: 36px;">{{ Number(data.currentDebt || 0).toLocaleString() }}₫</td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- Signature Area -->
    <div class="signature-section d-flex justify-content-around mt-5 pt-3">
      <div class="sig-box text-center">
        <div class="font-weight-bold mb-5 pb-5">KHÁCH HÀNG</div>
        <div class="mt-5 pt-4 text-muted">(Ký, ghi rõ họ tên)</div>
      </div>
      <div class="sig-box text-center">
        <div class="font-weight-bold mb-5 pb-5">NGƯỜI LẬP PHIẾU</div>
        <div class="mt-5 pt-4 text-muted">(Ký, ghi rõ họ tên)</div>
      </div>
    </div>

    <!-- Footer -->
    <div class="footer-section text-center mt-5 pt-4">
      <div class="footer-note mb-1">
        <i>Cảm ơn sự hợp tác của Quý khách!</i>
      </div>
      <div class="software-credit small text-muted">
        Phần mềm quản lý bán hàng - cuongdev.pro.vn
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DebtReceiptTemplate',
  props: {
    data: {
      type: Object,
      required: true
    },
    config: {
      type: Object,
      default: () => ({
        title: 'PHIẾU BIÊN NHẬN THANH TOÁN'
      })
    },
    settings: {
      type: Object,
      default: () => ({
        showCompanyLogo: true
      })
    },
    system: {
      type: Object,
      default: () => ({
          storeName: 'Cửa hàng Lô Gạch',
          address: 'Chưa cập nhật',
          phone: '',
          logo: ''
      })
    }
  },
  methods: {
    formatDateTime(dateStr) {
      if (!dateStr) return '';
      const d = new Date(dateStr);
      return d.toLocaleString('vi-VN', {
        hour: '2-digit', minute:'2-digit',
        day: '2-digit', month: '2-digit', year: 'numeric'
      });
    }
  }
}
</script>

<style scoped>
.debt-receipt-template {
  font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif;
  color: #000;
  width: 100%;
  padding: 0;
  margin: 0;
  background-color: white;
  box-sizing: border-box;
  font-size: 16px;
}
.table-bordered th, .table-bordered td {
  border: 1px solid #000 !important;
  padding: 12px 15px;
  font-size: 16px;
}
.company-name {
  font-size: 1.5rem !important;
}
.bill-title {
  font-size: 1.8rem !important;
}

@media print {
  .debt-receipt-template {
    width: 100% !important;
    max-width: 100% !important;
    padding: 0 !important;
    margin: 0 !important;
    font-size: 27px;
    box-sizing: border-box !important;
  }
  .company-name {
    font-size: 39px !important;
  }
  .company-detail {
    font-size: 27px;
    margin-bottom: 9px;
  }
  .bill-title {
    font-size: 42px !important;
    margin-top: 45px !important;
    margin-bottom: 45px !important;
  }
  .info-left, .info-right {
    font-size: 27px;
  }
  .info-row {
    margin-bottom: 22px !important;
  }
  .table-bordered th, .table-bordered td {
    padding: 24px 22px !important;
    font-size: 27px;
  }
  .sig-box .font-weight-bold {
    font-size: 27px;
    margin-bottom: 120px !important;
  }
  .sig-box .text-muted {
    font-size: 24px;
    color: #333 !important;
  }
  .footer-note {
    font-size: 27px;
    margin-top: 30px;
  }
  .software-credit {
    font-size: 21px;
  }
}
</style>
